module.exports = __webpack_public_path__ + "media/icons/przebieg-green-40623368.svg";